import { TransactionItem } from 'graphql'

function render( items: TransactionItem[] ) {
	const total = items.reduce( ( sum, item ) => sum + ( item.costPerItem * item.quantityOrdered ), 0 )

	return `$${total.toFixed( 2 )}`
}

export default {
	field: 'transactionItems',
	name: 'Cost',
	align: 'right',
	render,
}
